const investmentFAQ = [
  {
    id: 0,
    question: "What is Ballers?",
    answer: (
      <div>
        <p>
          Ballers is an exclusive sports membership that gives you unlimited
          access to 10,000+ courts, turfs, and sports clubs worldwide for a
          one-time lifetime fee of ₹1,00,000 + GST.
        </p>
      </div>
    ),
  },
  {
    id: 1,
    question: "Why is there a one-time fee instead of a monthly subscription?",
    answer: (
      <div>
        <p>
          Instead of charging you every month, we make it simple: pay once and
          get unlimited access for life. This saves you ₹5L+ over 10 years
          compared to traditional pay-per-play models.
        </p>
      </div>
    ),
  },
  {
    id: 2,
    question: "What happens after I pay for the membership?",
    answer: (
      <div>
        <p>You get instant access to our platform, where you can:</p>
        <p>✅ Browse & book courts in your city</p>
        <p>✅ Check-in via QR code at our partnered venues</p>
        <p>✅ Join exclusive sports events & tournaments</p>
        <p>✅ Be part of the Ballers community on WhatsApp</p>
      </div>
    ),
  },
  {
    id: 3,
    question: "What sports can I play with my Ballers membership?",
    answer: (
      <div>
        <p>You get access to multiple sports, including:</p>
        <p>
          🏀 Basketball | ⚽ Football | 🎾 Tennis | 🏏 Cricket | 🏓 Table Tennis
          | 🏐 Pickleball | 🏸 Badminton | ⚡ Padel
        </p>
      </div>
    ),
  },
  {
    id: 4,
    question: "Where are the courts and turfs located?",
    answer: (
      <div>
        <p>
          We are currently launching in India (Chennai, Bangalore, Hyderabad,
          Mumbai, Delhi NCR, Pune) and UAE (Dubai). We will be expanding to 50+
          global cities within the next 12 months.
        </p>
      </div>
    ),
  },
  {
    id: 5,
    question: "How do I book a court?",
    answer: (
      <div>
        <p>1️⃣ Open the Ballers platform and select your city</p>
        <p>2️⃣ Browse available courts and choose your preferred slot</p>
        <p>3️⃣ Book instantly (or join an existing game)</p>
        <p>4️⃣ Check-in with your QR code at the venue</p>
      </div>
    ),
  },
  {
    id: 6,
    question: "What if my preferred court is not listed?",
    answer: (
      <div>
        <p>
          You can request a location/facility directly from the app. Our team
          will work on adding it to the network.
        </p>
      </div>
    ),
  },
  {
    id: 7,
    question: "Can I book any time I want?",
    answer: (
      <div>
        <p>
          Yes, but slots are subject to availability. It is on a first come
          first serve basis.
        </p>
      </div>
    ),
  },
  {
    id: 8,
    question: "What happens if a court is fully booked?",
    answer: (
      <div>
        <p>If your preferred court is full, you can:</p>
        <p>✔ Book another time slot</p>
        <p>✔ Choose a different nearby court</p>
        <p>✔ Join a pickup game with other members</p>
      </div>
    ),
  },
  {
    id: 9,
    question: "What if I don’t play for a few months? Do I lose my membership?",
    answer: (
      <div>
        <p>
          No! Your membership never expires, whether you play every day or take
          a break.
        </p>
      </div>
    ),
  },
  {
    id: 10,
    question: "What if the court is under maintenance or unavailable?",
    answer: (
      <div>
        <p>If a booked court is under maintenance, you’ll be offered:</p>
        <p>✔ An alternate slot at the same venue</p>
        <p>✔ A different nearby facility</p>
      </div>
    ),
  },
  {
    id: 11,
    question: "Can I cancel a booking after making it?",
    answer: (
      <div>
        <p>You can cancel within the given window and rebook another slot.</p>
      </div>
    ),
  },
  {
    id: 12,
    question: "What if I book a slot but don’t show up?",
    answer: (
      <div>
        <p>
          Ballers promotes fair access to courts for all members. If you fail to
          show up without canceling:
        </p>
        <p>
          1️⃣ First 3 instances: You will receive a warning and a reminder to
          cancel in advance.
        </p>
        <p>
          2️⃣ After 3 warnings: Your membership will be temporarily suspended
          from booking courts.
        </p>
        <p>
          3️⃣ To reactivate: You may need to pay a penalty fee or serve a
          cooldown period.
        </p>
        <p>
          👉 This ensures that everyone gets a fair chance to play and prevents
          unnecessary blocking of slots.
        </p>
      </div>
    ),
  },
  {
    id: 13,
    question: "What are the benefits of being a Ballers member?",
    answer: (
      <div>
        <p>🚀 Unlimited access to 10,000+ courts worldwide</p>
        <p>🎾 No per-session fees – play as much as you want</p>
        <p>🏆 Exclusive tournaments & events</p>
        <p>🤝 Private WhatsApp community</p>
        <p>
          💰 Save ₹5,00,000+ over 10 years compared to traditional pay-per-play
          models
        </p>
        <p>💎 Socialize and meet like-minded people across the world</p>
      </div>
    ),
  },
  {
    id: 14,
    question: "Can I bring a friend who isn’t a Ballers member?",
    answer: (
      <div>
        <p>There are limited guest passes.</p>
      </div>
    ),
  },
  {
    id: 15,
    question: "Can I transfer my membership to someone else?",
    answer: (
      <div>
        <p>No, the membership is non-transferable.</p>
      </div>
    ),
  },
  {
    id: 16,
    question: "Is the membership refundable?",
    answer: (
      <div>
        <p>
          No, since this is a lifetime membership, it is non-refundable after
          purchase.
        </p>
      </div>
    ),
  },
  {
    id: 17,
    question: "How do I refer friends and earn rewards?",
    answer: (
      <div>
        <p>
          Inside the app, you’ll get a referral code. Share it, and when your
          friends join, you earn exclusive perks and rewards!
        </p>
      </div>
    ),
  },
];

export default investmentFAQ;
